export const classes = {
  body: 'place-center flex-col gap-2 w-full min-h-[5rem]',
  checkbox: 'w-5 h-5 shrink-0',
  checkboxChecked: 'text-brand-orange',
  checkboxUnchecked: 'text-grey-5 dark:text-mauve-3',
  image: 'object-contain h-16 w-auto',
  label: 'text-sm font-medium text-grey-8 dark:text-mauve-1',
};
